// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"298":"b6492384","880":"0c9ab723"}[chunkId] + ".chunk.css";
};